import React, { useEffect, useRef, useContext, useMemo, useState, useCallback } from 'react';
import ReactFlow, { Background, useReactFlow } from 'reactflow';
import 'reactflow/dist/style.css';
import CanvasContext from '../../../context/CanvasContext';
import AdminCanvasNode from './AdminCanvasNode';
import AdminCanvasEdge from './AdminCanvasEdge';
import styles from '../../classrooms/classroomcanvas/styles/ClassroomCanvas.module.css';
import socket from './../../../socket';

const AdminCanvas = ({ setModal }) => {
    const {
        nodes,
        edges,
        loading,
        onSelectEdgeAdmin,
        onSelectNodeAdmin,
        onCanvasClickAdmin,
        adminSelectedEdge,
        adminSelectedNode,
        setAdminSelectedEdge,
        setAdminSelectedNode,
    } = useContext(CanvasContext);
    
    const reactFlowWrapper = useRef(null);
    const { getZoom, setCenter } = useReactFlow();
    
    useEffect(() => {
        if (!loading && nodes.length > 0) {
            const startNode = nodes.find((node) => node.data?.endpointType === 'start');
            const nodeToCenter = startNode || nodes[0];

            if (nodeToCenter && nodeToCenter.position) {
                const { x, y } = nodeToCenter.position;
                const zoom = getZoom();
                setCenter(x, y, { zoom, duration: 800 });
            }
        }
    }, [loading, nodes, getZoom, setCenter]);

    const onNodeClick = (event, node) => {
        event.stopPropagation();
        console.log("node id", adminSelectedNode, node.id);
        if (adminSelectedNode && adminSelectedNode.id === node.id) {
            onCanvasClickAdmin();
        } else {
            onSelectNodeAdmin(node);
            setModal(true);
        }
    };

    const onEdgeClick = (event, edge) => {
        event.stopPropagation();
        if (adminSelectedEdge && adminSelectedEdge.id === edge.id) {
            onCanvasClickAdmin();
        } else {
            onSelectEdgeAdmin(edge);
            setModal(true);
        }
    };

    const nodeTypes = useMemo(() => ({
    situation: (nodeProps) => {
        const nodeId = nodeProps.id;
        const isSelected = adminSelectedNode && adminSelectedNode.id === nodeId;
        return <AdminCanvasNode {...nodeProps} selected={isSelected}/>;
    }
}), [adminSelectedNode]);

    const edgeTypes = useMemo(() => ({
        choice: AdminCanvasEdge,
        smart: AdminCanvasEdge,
    }), []);

    if (loading) {
        return <div className={styles.loading}>Loading Canvas...</div>;
    }

    return (
        <div
            className={styles.container}
            ref={reactFlowWrapper}
            onDragOver={(event) => event.preventDefault()}
        >

            <ReactFlow
                nodes={nodes}
                edges={edges}
                nodeTypes={nodeTypes}
                edgeTypes={edgeTypes}
                onNodeClick={onNodeClick}
                onEdgeClick={onEdgeClick}
                onPaneClick={onCanvasClickAdmin}
                deleteKeyCode={null}
            >
                <Background color="#aaa" gap={16} />
            </ReactFlow>
        </div>
    );
};

export default AdminCanvas;